import React from 'react'
import last from 'lodash/last'
import { Breadcrumb } from '@ztechapps/webui.page'
import type { BreadcrumbItem } from '@ztechapps/webui.page'

type PivotBreadcrumbsProps = { crumbs?: BreadcrumbItem[]; template?: { name?: string } }

export const PivotBreadcrumbs = ({ crumbs, template }: PivotBreadcrumbsProps) => {
  const templateName = template?.name

  const breadcrumbs = React.useMemo(() => {
    const firstItems = crumbs?.slice(0, crumbs?.length - 1)
    const lastItem: BreadcrumbItem | undefined = last(crumbs)
    const lastName = templateName ? `${lastItem?.name} - ( ${templateName} )` : lastItem?.name
    return [...firstItems, { ...lastItem, name: lastName }]
  }, [templateName, crumbs])

  return <Breadcrumb items={breadcrumbs} />
}
